import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Autosave = _resolveComponent("Autosave")
  const _component_BuilderInputs = _resolveComponent("BuilderInputs")
  const _component_SettingsFrame = _resolveComponent("SettingsFrame")

  return (_openBlock(), _createBlock(_component_SettingsFrame, {
    title: "All Agents",
    class: "all-agents"
  }, {
    description: _withCtx(() => _cache[0] || (_cache[0] = [
      _createTextVNode(" Enables the AI agents (Person Card, Company Card, Meeting Prep Card) to incorporate insights, news, and trends "),
      _createElementVNode("br", null, null, -1 /* HOISTED */),
      _createTextVNode(" from the user’s favorite sources, ensuring that all cards stay current with trusted, relevant information ")
    ])),
    right: _withCtx(() => [
      _createVNode(_component_Autosave, {
        saving: $data.saving,
        saved_at: $data.saved_at
      }, null, 8 /* PROPS */, ["saving", "saved_at"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_BuilderInputs, {
        opts: $data.schema,
        class: "builder",
        onUpdate: $options.onUpdate
      }, null, 8 /* PROPS */, ["opts", "onUpdate"])
    ]),
    _: 1 /* STABLE */
  }))
}